import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _getFeedbackItems = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url = params ? `${window.config.VUE_APP_BACKEND}/api/feedback-items?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/feedback-items`

  return Request.get(
    url,
    config
  )
}

const _getFeedbackItemsSummary = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url = `${window.config.VUE_APP_BACKEND}/api/feedback-items/summary?${params.q}`

  return Request.get(
    url,
    config
  )
}

const _deleteFeedbackItem = feedbackItemId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(
    `${window.config.VUE_APP_BACKEND}/api/feedback-items/${feedbackItemId}`,
    config
  )
}

export default {
  getFeedbackItems: _getFeedbackItems,
  getFeedbackItemsSummary: _getFeedbackItemsSummary,
  deleteFeedbackItem: _deleteFeedbackItem
}
